
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark mb-4">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">RunCodeAnytime.io</a>
    <button
      class="navbar-toggler"
      type="button"
      data-mdb-toggle="collapse"
      data-mdb-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <i class="fas fa-bars"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" routerLink="/">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/typescript-to-java">TypeScript to JAVA</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/">XmlToJson Converter</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/code-runner">Online Compiler</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/">JSON Validator</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" routerLink="/" tabindex="-1" aria-disabled="true"
            >About</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>


